const n = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M4.488,3.12a.25.25,0,0,0-.25-.25H1.5a1,1,0,0,0-1,.989V4.882a.994.994,0,0,0,1,.988H4.242a.249.249,0,0,0,.25-.25Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
    <path
        d="M9.5,3.859a1,1,0,0,0-1-.989H5.738a.252.252,0,0,0-.177.074.249.249,0,0,0-.073.177l0,2.5a.249.249,0,0,0,.25.249H8.5a.994.994,0,0,0,1-.988Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
    <path
        d="M4.5,7.12a.251.251,0,0,0-.25-.25H1.5a.5.5,0,0,0-.5.5V8.882A.994.994,0,0,0,2,9.87H4.249A.251.251,0,0,0,4.426,9.8.255.255,0,0,0,4.5,9.62Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
    <path
        d="M5.745,6.87a.25.25,0,0,0-.177.074.245.245,0,0,0-.073.177l0,2.5a.249.249,0,0,0,.25.249H8a.994.994,0,0,0,1-.988V7.37a.5.5,0,0,0-.5-.5Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
    <path d="M6.8.23a.5.5,0,0,0-.7.1L5,1.8,3.9.33a.5.5,0,0,0-.8.6l1.5,2a.5.5,0,0,0,.8,0l1.5-2A.5.5,0,0,0,6.8.23Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
</svg>`;
export {
  n as default
};
